import React from 'react';
import Text from '../Text/Text';
import SectionTitle from '../SectionTitle/SectionTitle';
import Button from '../Button/Button';
import './JoinText.css';

const JoinText = ({ classname }) => (
  <div className={`JoinText ${classname}`}>
    <SectionTitle greenLight={true} classname="JoinText__title">
      Vous voulez être coopérateur ?
    </SectionTitle>
    <Text classname="JoinText__title">
      La force du collectif, c'est de partager des valeurs communes
    </Text>
    <Text>
      <strong>L'indépendance : </strong> pour redonner du sens à l'autonomie
    </Text>
    <Text>
      <strong>La transparence : </strong> pour établir une relation saine au
      sein de notre réseau
    </Text>
    <Text>
      <strong>La bienveillance : </strong> pour garantir la participation
      éclairée de chacun
    </Text>
    <Text>
      <strong>La performance : </strong> pour gagner en efficacité envers les
      patients et les laboratoires
    </Text>
    <Text>
      <strong>L'innovation : </strong> pour s'adapter aux évolutions du métier
      du pharmacien
    </Text>
    <Text>
      <strong>La flexibilité : </strong> pour proposer des solutions à toutes
      les typologies de pharmacies
    </Text>
    <Text classname="JoinText__space">
      <strong>Vous êtes Pharmacie COS compatible ?</strong>
    </Text>
    <Text classname="JoinText__title" greenLight={true}>
      <strong>REJOIGNEZ-NOUS !</strong>
    </Text>
    <div className="JoinText__buttons">
      <form className="JoinText__button" action="tel:0143415301">
        <Button type="submit" greenLight={true}>
          01 43 41 53 01
        </Button>
      </form>
      <a className="JoinText__button" href="mailto:contact@cospharmacie.fr">
        <Button type="button" green={true}>
          contact@cospharmacie.fr
        </Button>
      </a>
    </div>
  </div>
);

export default JoinText;
